// src/components/Layout.jsx
import { Outlet, useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageSEO from "./PageSEO";

const Layout = () => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    } else if (!lang) {
      i18n.changeLanguage('en');
    }

    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [lang, location, i18n]);

  return (
    <>
      <PageSEO />
      <Outlet />
    </>
  );
};

export default Layout;
